import { render, staticRenderFns } from "./payreceivable.vue?vue&type=template&id=8100bf06&scoped=true&"
import script from "./payreceivable.vue?vue&type=script&lang=js&"
export * from "./payreceivable.vue?vue&type=script&lang=js&"
import style0 from "./payreceivable.vue?vue&type=style&index=0&id=8100bf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8100bf06",
  null
  
)

export default component.exports